import { commonKey } from "@/common/config/constant";
export default {
  now:
    Date.now ||
    function () {
      return new Date().getTime();
    },
  isArray:
    Array.isArray ||
    function (obj) {
      return obj instanceof Array;
    },
  // 获取当前路径加参数
  curRoutePath: function () {
    let routes = getCurrentPages(); // 获取当前打开过的页面路由数组
    let curRoute = routes[routes.length - 1].route; //获取当前页面路由
    let curParam = routes[routes.length - 1].options; //获取路由参数
    // 拼接参数
    let param = "";
    let index = 0;
    for (let key in curParam) {
      if (index == 0) {
        param += "?" + key + "=" + curParam[key];
      } else {
        param += "&" + key + "=" + curParam[key];
      }
      index += 1;
    }
    curRoute += param;
    return curRoute;
  },
  // 参数对象转链接参数
  transRoutPath: function (route, curParam) {
    let param = "";
    let index = 0;
    for (let key in curParam) {
      if (index == 0) {
        param += "?" + key + "=" + curParam[key];
      } else {
        param += "&" + key + "=" + curParam[key];
      }
      index += 1;
    }
    route += param;
    return route;
  },
  goRedirectPath: function (url) {
    let redirectUrl = uni.getStorageSync("redirectUrl");
    if (redirectUrl) {
      url = redirectUrl;
    }
    uni.navigateTo({
      url: url,
    });
  },
  getParam(path, name) {
    var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");

    if (reg.test(path)) return unescape(RegExp.$2.replace(/\+/g, " "));

    return "";
  },

  need_login() {
    uni.showModal({
      title: "提示",
      content: "暂未登录，是否前往登录",
      success: function (ress) {
        if (ress.confirm) {
          uni.navigateTo({
            url: "/pages/login/login",
          });
        } else {
          uni.switchTab({
            url: "/pages/index/index",
          });
        }
      },
    });
  },

  check_login() {
    let user =
      uni.getStorageSync("user") || uni.getStorageSync(commonKey.TOKEN_KEY);
    if (!user) {
      uni.showModal({
        title: "提示",
        content: "暂未登录，是否前往登录",
        success: function (ress) {
          if (ress.confirm) {
            uni.navigateTo({
              url: "/pages/login/login",
            });
          } else {
            uni.switchTab({
              url: "/pages/index/index",
            });
          }
        },
      });
    }
  },
  GetUrlRelativePath() {
    var url = document.location.toString();
    var arrUrl = url.split("?");
    return arrUrl[0];
  },
  getJobTreeInfo(list, job_id, show_all) {
    let name = "";
    let twoList = [];
    let child = {};
    let childs = [];
    let childs3 = [];
    let childs3s = [];

    // list.unshift({
    // 	id:'', name:'全部', level:0, child:[{
    // 		id:'', name:'全部', level:1, child:[{
    // 			id:'', name:'全部', level:2
    // 		}],
    // 	}]
    // })
    let lev_2_id = "";
    for (let i = 0; i < list.length; i++) {
      // list[i].child.unshift({id:'', name:'全部', child:[
      // 	{id:'', name:'全部'}
      // ]})
      if (show_all) {
        list[i].child.unshift({ id: "", name: "全部", pid: list[i].id });
      }

      list[i].selected = false;

      let child1 = list[i].child;
      for (let a = 0; a < child1.length; a++) {
        child = list[i].child[a];
        child.selected = false;

        // if(job_id == '' && i==0 && a==0){
        // 	childs = list[i].child
        // 	childs3s = list[i].child[a].child
        // }

        if (typeof list[i].child[a].child != "undefined") {
          if (show_all) {
            list[i].child[a].child.unshift({
              id: "",
              name: "全部",
              pid: list[i].child[a].id,
            });
          }

          for (let j = 0; j < list[i].child[a].child.length; j++) {
            childs3 = list[i].child[a].child[j];
            if (job_id == list[i].child[a].child[j].id && job_id != "") {
              // if (job_id == list[i].child[a].child[j].id) {
              list[i].selected = true;
              list[i].child[a].selected = true;
              child.selected = true;
              list[i].child[a].child[j].selected = true;
              list[i].child[a] = child;
              childs = list[i].child;
              childs3s = list[i].child[a].child;
              name = list[i].child[a].child[j].name;
            }
          }

          if (job_id == list[i].child[a].id && job_id != "") {
            list[i].selected = true;
            childs = list[i].child;
            childs3s = list[i].child[a].child;
            name = list[i].child[a].name;
            childs[a].selected = true;
            if (show_all) {
              childs3s[0].selected = true;
            }
          }
        }
      }

      if (job_id == list[i].id && job_id != "") {
        childs = list[i].child;
        name = list[i].name;
        list[i].selected = true;
        if (show_all) {
          childs[0].selected = true;
        }
      }
    }

    // if(list.length > 0 && job_id == ''){
    // 	list[0].selected = true
    // }

    let list1 = list;
    let list2 = childs;
    let list3 = childs3s;

    let currJobInfo = { id: job_id, name: name };

    return { list1, list2, list3, currJobInfo };
  },
  dumpTo(link) {
    const str = new RegExp("http");
    if (str.test(link)) {

      window.location.href = link;







    } else {
      uni.navigateTo({
        url: link,
      });
    }
  },
  handleBreadthQuery(treeList, id) {
    let _this = this;
    for (let i = 0; i < treeList.length; i++) {
      let treeItem = treeList[i];
      if (treeItem.id == id) {
        return treeItem;
      } else {
        if (treeItem.children && treeItem.children.length > 0) {
          let res = _this.handleBreadthQuery(treeItem.children, id);
          if (res) {
            return res;
          }
        }
      }
    }
  },
  getParentTree(id, tree) {
    let arr = []; //要返回的数组
    for (let i = 0; i < tree.length; i++) {
      let item = tree[i];
      arr = [];
      arr.push(item); //保存当前节点id
      if (id == item.id) {
        //判断当前id是否是默认id
        return arr; //是则退出循环、返回数据
      } else {
        //否则进入下面判断，判断当前节点是否有子节点数据
        if (item.children && item.children.length > 0) {
          //合并子节点返回的数据
          arr = arr.concat(
            this.getParentTree(id, item.children ? item.children : [])
          );
          if (arr.map((item2) => (item2 ? item2.id : "")).includes(id)) {
            //如果当前数据中已包含默认节点，则退出循环、返回数据
            return arr;
          }
        }
      }
    }
  },
  getParentId(list, id) {
    for (let i in list) {
      if (list[i].id == id) {
        return [list[i]];
      }
      if (list[i].children != null) {
        let node = this.getParentId(list[i].children, id);
        if (node !== undefined) {
          return [list[i]].concat(node);
        }
      }
    }
  },
  async handleRegionApi() {
    let that = getCurrentPages()[0].$vm;
    const res = await that.$u.api.getSiteRegionTreeList({ type: "edit" });
    const res1 = await that.$u.api.getSiteRegionTreeList({ type: "filter" });
    const res2 = await that.$u.api.getSiteRegionTreeList({ type: "no_all" });
    that.$store.commit("setEditRegionList", res.data);
    that.$store.commit("setFilterRegionList", res1.data);
    that.$store.commit("setNoAllRegionList", res2.data);
  },
};
